import {
    Box,
    Button,
    Flex,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
} from '@chakra-ui/react';
import { oBIcons } from '../components/Icons';
import { PlusSquareIcon } from '@chakra-ui/icons';
import { formatDate } from 'utils/utils';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useGetMeeting } from 'hooks/useMeeting';
import moment from 'moment';

const meetingArr = [
    {
        id: 1,
        title: 'Weekly Sales Sync',
        dueDate: '2025-05-21',
        time: '6PM - 7PM',
        location: 'Google Meet',
        participants: 'Korede, Oge, Elvis',
        host: 'Ochije Nnani',
        salesperson: 'Stephen Salesperson',
        relatedTo: '??',
        repeat: true,
        reminder: true,
    },
    {
        id: 2,
        title: 'Weekly Sales Sync',
        dueDate: '2025-05-21',
        time: '6PM - 7PM',
        location: 'Google Meet',
        participants: 'Korede, Oge, Elvis',
        host: 'Ochije Nnani',
        salesperson: 'Stephen Salesperson',
        relatedTo: '??',
        repeat: true,
        reminder: true,
    },
];

function MeetingSummaryModal({ isOpen, onClose, meeting }) {
    if (!meeting) return null;
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent borderRadius="lg">
                <ModalHeader fontWeight="bold" color="#1B3B5F">
                    Meeting Summary
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontWeight="bold" fontSize="xl" mb={4}>
                        {meeting.Event_Title}
                    </Text>
                    <Box
                        as="dl"
                        display="grid"
                        gridTemplateColumns="1fr 1fr"
                        rowGap={3}
                        columnGap={4}
                        mb={6}>
                        <Text color="#667085">Location</Text>
                        <Text textAlign={'right'}>{meeting.Venue}</Text>
                        <Text color="#667085">Due Date</Text>
                        <Text textAlign={'right'}>
                            {formatDate(new Date(meeting.Start_DateTime))}
                        </Text>
                        <Text color="#667085">Time</Text>
                        <Text textAlign={'right'}>
                            {meeting.Start_DateTime
                                ? moment(meeting.Start_DateTime).format('h:mm a')
                                : 'N/A'}
                        </Text>
                        <Text color="#667085">Host</Text>
                        <Text textAlign={'right'}>{meeting?.Created_By?.name ?? 'N/A'}</Text>
                        <Text color="#667085">Salesperson</Text>
                        <Text textAlign={'right'}>{meeting?.What_Id?.name || 'N/A'}</Text>
                        <Text color="#667085">Participants</Text>
                        <Text textAlign={'right'}>
                            {meeting?.Participants?.map((participant) => participant.name).join(
                                ', ',
                            ) || 'N/A'}
                        </Text>
                        <Text color="#667085">Related to</Text>
                        <Text textAlign={'right'}>{meeting.relatedTo || 'N/A'}</Text>
                        <Text color="#667085">Repeat Settings</Text>
                        <Text textAlign={'right'}>{meeting.repeat ? 'Enabled' : 'Disabled'}</Text>
                        <Text color="#667085">Reminder Settings</Text>
                        <Text textAlign={'right'}>{meeting.reminder ? 'Enabled' : 'Disabled'}</Text>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="white"
                        bg="#1b3b5f"
                        mr={3}
                        borderRadius="12px"
                        px={8}
                        fontWeight="bold">
                        Mark as Complete
                    </Button>
                    <Button
                        color="#1b3b5f"
                        bg="#B8C1D380"
                        borderRadius="12px"
                        px={8}
                        fontWeight="bold"
                        onClick={onClose}>
                        Edit Meeting
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

const Meeting = () => {
    const navigate = useNavigate();
    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const { meetings, isLoading } = useGetMeeting();
    return (
        <Box>
            <Box
                display={'flex'}
                flexDir={{ base: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={{ md: 'center' }}>
                <Flex gap="2" alignItems={'center'} color={'#1B3B5F'} fontWeight={'500'}>
                    {oBIcons.meeting}
                    <Text fontSize={{ base: 'lg', lg: 'xl' }}>MY MEETINGS</Text>
                </Flex>
                <Button
                    color="#1b3b5f"
                    bg="#B8C1D380"
                    mt="15px"
                    fontWeight="500"
                    borderRadius="8px"
                    h="48px"
                    fontSize={{ base: 'lg', lg: 'xl' }}
                    gap="2"
                    outline="none"
                    onClick={() => navigate('/dashboard/crm/create-meeting')}>
                    <PlusSquareIcon />
                    New Meeting
                </Button>
            </Box>

            {isLoading ? (
                <Box>Loading...</Box>
            ) : meetingArr?.length === 0 ? (
                <Box
                    minH={'40vh'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    color={'#667085'}>
                    No Avaliable Meeting
                </Box>
            ) : (
                <Box mt="5">
                    <TableContainer border="1px solid #EAECF0" borderRadius="lg">
                        <Table variant="simple" size="sm">
                            <Thead bg={'#F9FAFB'}>
                                <Tr>
                                    <Th textAlign={'center'} py="4">
                                        Title
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Date
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Time
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Location
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Participants
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {meetings?.map((meeting, i) => (
                                    <Tr
                                        fontSize="xs"
                                        key={meeting.id}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedMeeting(meeting);
                                            setIsSummaryOpen(true);
                                        }}>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {meeting?.Event_Title ?? 'N/A'}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            <Text>
                                                {formatDate(new Date(meeting.Start_DateTime))}
                                            </Text>
                                        </Td>

                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {meeting?.Start_DateTime
                                                ? moment(meeting?.Start_DateTime).format('h:mm a')
                                                : 'N/A'}
                                        </Td>
                                        <Td
                                            py="4"
                                            textAlign={'center'}
                                            borderRight="1px solid #EAECF0">
                                            {meeting?.Venue ?? 'N/A'}
                                        </Td>
                                        <Td py="4" textAlign={'center'} maxW={'28'} isTruncated>
                                            {meeting?.Participants?.map(
                                                (participant) => participant.name,
                                            ).join(', ') ?? 'N/A'}
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            )}
            <MeetingSummaryModal
                isOpen={isSummaryOpen}
                onClose={() => setIsSummaryOpen(false)}
                meeting={selectedMeeting}
            />
        </Box>
    );
};

export default Meeting;
